export default __webpack_public_path__ + "images/0xd6070ae98b8069de6b494332d1a1a81b6179d960.png";